import { HRF_DOCUMENT_ACCEPTED_FORMATS, TAGGING_IDS } from '../../config/constant';

const HrfDocumentSection = ({ editable, errors = {}, title, basic_details = {}, handleChangeHrfDoc, handleRemoveHrfDoc, handleDocClick = ()=>{} }) => {
    const getRequiredAsterisk = (taggingId, allowedTaggingIds) => {
        return allowedTaggingIds.includes(taggingId) ? '*' : '';
    };
    
    if(editable){
    return (
        <>
          <div className='cbi_info_wrapper' style={{gap: '2rem'}}>
                 <div className="img-bx-select-opt" style={{width: 280, textAlign: 'center'}}>
                    <div className="image-bx cbi-img-bx" style={{width: '100%'}} >
                        {basic_details?.nib_document_url &&
                        <>
                            <i className='ic-clearclose' onClick={()=>handleRemoveHrfDoc("nib_document_url", "nib_document_file")}></i>
                            <iframe
                                
                                src={basic_details.nib_document_url}
                                title="NIB Document"
                                width="100%"
                                height="100%"
                                style={{ border: "1px solid #ddd", borderRadius: "6px" }}
                            />
                        </>
                        }
                        {!basic_details?.nib_document_url &&
                            <div className="image-bx more-file-upload">
                                <i className='ic-add'></i>
                                <input
                                    type="file"
                                    name="nib_document_file"
                                    accept={HRF_DOCUMENT_ACCEPTED_FORMATS}
                                    className="upload"
                                    onChange={(e)=>handleChangeHrfDoc(e, "nib_document_url", "nib_document_file")}
                                />
                                <p>NIB Document{getRequiredAsterisk(basic_details["tagging_id"], [TAGGING_IDS.PROPERTY_BROKER])}</p>
                            </div>
                        }
                    </div>
                    {basic_details?.nib_document_url ? <span>NIB Document{getRequiredAsterisk(basic_details["tagging_id"], [TAGGING_IDS.PROPERTY_BROKER])}</span> : null}
                    {(errors && errors?.nib_document_url) ? <span className="error show">{errors?.nib_document_url}</span> : null}
                </div>
                <div className="img-bx-select-opt" style={{width: 280, textAlign: 'center'}}>
                    <div className="image-bx cbi-img-bx" style={{width: '100%'}} >
                        {basic_details?.npwp_perusahaan_url &&
                        <>
                            <i className='ic-clearclose' onClick={()=>handleRemoveHrfDoc("npwp_perusahaan_url", "npwp_perusahaan_file")}></i>
                            <iframe
                                
                                src={basic_details.npwp_perusahaan_url}
                                title="CBI Document"
                                width="100%"
                                height="100%"
                                style={{ border: "1px solid #ddd", borderRadius: "6px" }}
                            />
                        </>
                        }
                        {!basic_details?.npwp_perusahaan_url &&
                            <div className="image-bx more-file-upload">
                                <i className='ic-add'></i>
                                <input
                                    type="file"
                                    name="doc_title"
                                    accept={HRF_DOCUMENT_ACCEPTED_FORMATS}
                                    className="upload"
                                    onChange={(e)=>handleChangeHrfDoc(e, "npwp_perusahaan_url", "npwp_perusahaan_file")}
                                />
                                <p>NPWP Perusahaan{getRequiredAsterisk(basic_details["tagging_id"], [TAGGING_IDS.PROPERTY_BROKER, TAGGING_IDS.RETAIL_AGENT])}</p>
                            </div>
                        }
                    </div>
                    {basic_details?.npwp_perusahaan_url ? <span>NPWP Perusahaan{getRequiredAsterisk(basic_details["tagging_id"], [TAGGING_IDS.PROPERTY_BROKER, TAGGING_IDS.RETAIL_AGENT])}</span> : null}
                    {(errors && errors?.npwp_perusahaan_url) ? <span className="error show">{errors?.npwp_perusahaan_url}</span> : null}
                </div>
          </div>
        </>
      );
  }

  

  return (
    <>
      {title ? <div className='top-heading d-flex'> <h2>{title}</h2> </div> : null}

      <div className='cbi_info_wrapper'>
             <div className="img-bx-select-opt" style={{width: 280, textAlign: 'center'}}>
                    <div className="image-bx cbi-img-bx" style={{width: '100%'}}>
                        {basic_details?.nib_document_url &&
                        <>
                            {/* <i className='ic-save' title='Download' onClick={handleDocClick}></i>  */}
                            <iframe
                                src={basic_details?.nib_document_url}
                                title="CBI Document"
                                width="100%"
                                height="100%"
                                style={{ border: "1px solid #ddd", borderRadius: "6px" }}
                            />
                        </>
                        }
                        {!basic_details?.nib_document_url &&
                            <div className="image-bx more-file-upload">
                                <input
                                    disabled={true}
                                    type="file"
                                    name="doc_title"
                                    accept={HRF_DOCUMENT_ACCEPTED_FORMATS}
                                    className="upload"
                                    onChange={handleChangeHrfDoc}
                                />
                                <p>No preview available</p>
                            </div>
                        }
                    </div>
                    <span title='Download NIB Document' onClick={()=>handleDocClick(basic_details?.nib_document_url, "nib_document")} className='anchor-link'>NIB Document</span>
                </div>

                 <div className="img-bx-select-opt" style={{width: 280, textAlign: 'center'}}>
                    <div className="image-bx cbi-img-bx" style={{width: '100%'}}>
                        {basic_details?.npwp_perusahaan_url &&
                        <>
                            {/* <i className='ic-save' title='Download' onClick={handleDocClick}></i>  */}
                            <iframe
                                src={basic_details?.npwp_perusahaan_url}
                                title="CBI Document"
                                width="100%"
                                height="100%"
                                style={{ border: "1px solid #ddd", borderRadius: "6px" }}
                            />
                        </>
                        }
                        {!basic_details?.npwp_perusahaan_url &&
                            <div className="image-bx more-file-upload">
                                <input
                                    disabled={true}
                                    type="file"
                                    name="doc_title"
                                    accept={HRF_DOCUMENT_ACCEPTED_FORMATS}
                                    className="upload"
                                    onChange={handleChangeHrfDoc}
                                />
                                <p>No preview available</p>
                            </div>
                        }
                    </div>
                    <span title='Download NPWP Perusahaan' onClick={()=>handleDocClick(basic_details?.npwp_perusahaan_url, "npwp_perusahaan")} className='anchor-link'>NPWP Perusahaan</span>
                </div>
      </div>
    </>
  );
};

export default HrfDocumentSection;